import React from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '@domain-group/fe-co-icon/lib/js/close';
var onboardingImage = "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-map/static/land-details-onboarding_f9ea82f0.png";
import * as styles from './land-details-onboarding.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LandDetailsOnboarding = _ref => {
  var onTryOut = _ref.onTryOut,
    onClose = _ref.onClose;
  return ___EmotionJSX("div", {
    css: styles.container
  }, ___EmotionJSX("div", {
    css: styles.leftContainer
  }, ___EmotionJSX("img", {
    src: onboardingImage,
    alt: "Land Details",
    css: styles.image
  })), ___EmotionJSX("div", {
    css: styles.rightContainer
  }, ___EmotionJSX("div", {
    css: styles.title
  }, "There's a lot more to see"), ___EmotionJSX("div", {
    css: styles.text
  }, "Using overlays will allow you to see details such as school catchments, zoning and easements."), ___EmotionJSX("button", {
    css: styles.tryOutLink,
    onClick: onTryOut,
    type: "button"
  }, "Try it out"), ___EmotionJSX("button", {
    css: styles.closeButton,
    onClick: onClose,
    type: "button",
    "aria-label": "Close"
  }, ___EmotionJSX(CloseIcon, {
    size: "small"
  }))));
};
LandDetailsOnboarding.propTypes = {
  onTryOut: PropTypes.func,
  onClose: PropTypes.func
};
LandDetailsOnboarding.defaultProps = {
  onTryOut: () => {},
  onClose: () => {}
};
export default LandDetailsOnboarding;